import { Modal, Table } from 'antd';
import { type FC } from 'react';

import type { ModelMessageTemplate } from '@app/api/MessageTemplates';
import {
  CloseIconsForModalWithDataTestId,
  Error403Unauthorized,
} from '@app/components';
import { passTableHeader } from '@app/pages/Messages/MessageTemplatesRegistry/utils/passTableHeader';
import { getPaginationItemRenderWithDataTestIds } from '@app/utils';

import { useMessageTemplatesRegistry } from '@pages/Messages/MessageTemplatesRegistry/hooks/useMessageTemplatesRegistry';
import { useMessageTemplatesRegistryEffects } from '@pages/Messages/MessageTemplatesRegistry/hooks/useMessageTemplatesRegistryEffects';

import '@pages/Messages/MessageTemplatesRegistry/styles/MessageTemplatesRegistry.scss';

export const MessageTemplatesRegistry: FC = () => {
  const {
    page,
    pageSize,
    templates,
    setTemplates,
    isDeletionWindowOpen,
    setIsDeletionWindowOpen,
    deleteTemplate,
    hasUserRightToMessageTemplatesModule,
    setSearchId,
    rowsTotal,
    setRowsTotal,
    handleChange,
    activeTemplateId,
    setActiveTemplateId,
    isMobile,
  } = useMessageTemplatesRegistry();

  const { isLoading } = useMessageTemplatesRegistryEffects({
    pageSize,
    setTemplates,
    setSearchId,
    setRowsTotal,
  });

  if (!hasUserRightToMessageTemplatesModule) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="MessageTemplatesRegistry">
      <Table<ModelMessageTemplate>
        className="MessageTemplatesRegistry__table"
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 500 }}
        columns={passTableHeader(setIsDeletionWindowOpen, setActiveTemplateId)}
        rowClassName="MessageTemplatesRegistry__row"
        dataSource={templates}
        rowKey={({ Id }) => Id}
        loading={isLoading}
        pagination={{
          itemRender: getPaginationItemRenderWithDataTestIds,
          size: isMobile ? 'small' : 'default',
          align: 'start',
          current: page,
          pageSize,
          total: rowsTotal,
          showSizeChanger: true,
          showLessItems: isMobile,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) => (
            <span data-testid="pagination-info">
              {isMobile
                ? `Всего ${total}`
                : `Показаны ${range[0]}-${range[1]} из ${total}`}
            </span>
          ),
          onChange: handleChange,
        }}
      />

      <Modal
        title={
          <span data-testid="delete-template-title">Удаление шаблона</span>
        }
        destroyOnHidden
        open={isDeletionWindowOpen}
        okText="Удалить"
        okButtonProps={{ danger: true, 'data-testid': 'delete' }}
        cancelButtonProps={{ 'data-testid': 'cancel' }}
        onOk={() => deleteTemplate(activeTemplateId)}
        onCancel={() => setIsDeletionWindowOpen(false)}
        data-testid="delete-template-popup"
        closeIcon={<CloseIconsForModalWithDataTestId />}
      >
        <span data-testid="delete-template-description">
          Вы уверены, что хотите удалить шаблон сообщения?
        </span>
      </Modal>
    </div>
  );
};
